var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('form-impostos',{on:{"adicionar":_vm.adicionarTabela}}),_c('tabela-impostos',{attrs:{"items":_vm.impostos},on:{"remover":_vm.removerImposto}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }